import {injectable} from "inversify";
import {Graphics, Point, Container} from "pixi.js-legacy";
import {View} from "@dp-instant/2d";
const ARROW_COLOR = 0x5f80dd;
const ARROW_ALPHA = 0.7;
@injectable()
export class ArrowView extends View {
    private arrowCont: Container = new Container();
    private arrowTip: Graphics = new Graphics();
    private graphics: Graphics = new Graphics()
        .beginFill(ARROW_COLOR, ARROW_ALPHA)
        .drawRect(0, 0, 20, 20)
        .endFill();
    onAdded() {
        this.arrowTip
            .beginFill(ARROW_COLOR, ARROW_ALPHA)
            .lineTo(-20, 0)
            .lineTo(0, 30)
            .lineTo(20, 0)
            .endFill();
        this.addChild(this.arrowCont);
        this.graphics.x = -this.graphics.width * 0.5;
        this.arrowCont.addChild(this.graphics);
        this.arrowCont.addChild(this.arrowTip);
        super.onAdded();
    }
    setUpDirection(target: Point, fast = false) {
        const targetLocal = this.toLocal(target);
        const length = Math.sqrt(targetLocal.x * targetLocal.x + targetLocal.y * targetLocal.y);
        this.visible = length > this.arrowTip.height;
        this.arrowTip.y = this.graphics.height = length - this.arrowTip.height; // Math.min(length, 50);
        this.arrowCont.rotation = Math.atan2(targetLocal.y, targetLocal.x) - Math.PI / 2;
    }
}
